import { Box } from '@mui/material';
import { FunctionComponent } from 'react';

interface Props {
  title: string;
}

export const DashboardContactTitle: FunctionComponent<Props> = ({ title }) => {
  return <Box sx={{
    fontSize: '0.75rem',
    fontWeight: 400,
    color: '#788688',
    mb: 1,
  }}>{title}</Box>
}
